var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 12,
    viewBox: "0 0 214 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.53 6.53033C213.823 6.23744 213.823 5.76256 213.53 5.46967L208.757 0.696699C208.464 0.403806 207.99 0.403806 207.697 0.696699C207.404 0.989593 207.404 1.46447 207.697 1.75736L211.939 6L207.697 10.2426C207.404 10.5355 207.404 11.0104 207.697 11.3033C207.99 11.5962 208.464 11.5962 208.757 11.3033L213.53 6.53033ZM0 6.75H213V5.25H0V6.75Z",
    fill: "#863CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleArrow);
export default __webpack_public_path__ + "static/media/purple_arrow.18eed22a752273fd2989b2d3c8d2641f.svg";
export { ForwardRef as ReactComponent };